import script from "./udfSearch.vue?vue&type=script&setup=true&lang=js"
export * from "./udfSearch.vue?vue&type=script&setup=true&lang=js"

import "./udfSearch.vue?vue&type=style&index=0&id=72ca8786&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-72ca8786"]])

export default __exports__